<template>
  <div class="drawer-detail">
    <div v-for="field in fields" :key="field" class="field-type">
      <template v-if="field==='业务特点/风格/资源来源'">
        <span class="label">{{translateTag[field]||field}}:</span>
        <!-- <pre class="value company-pre ">{{company[field]}}</pre> -->
        <!-- <tagInputInShow :value="company[field]" :translate="translate"></tagInputInShow> -->
        <SearchTagInputShow :value="company[field]" :translate="translate" @quickEdit="quickEdit(field)" ></SearchTagInputShow>
      </template>
      <template v-else>
        <span class="label">{{translateTag[field]||field}}:</span>
        <div :class="[company[field]?'':'gray-text','value company-pre']">
          <p v-if="company[field]">{{company[field]}}</p>
          <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit(field)"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
// import tagInputInShow from '../../../../../company/src/baseComponent/tagInputInShow'
import SearchTagInputShow from './SearchTagInputShow'

export default {
  components: { SearchTagInputShow },
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['优势业务','业务特点/风格/资源来源', '人员风格'],
      translateTag: {
        '业务特点/风格/资源来源': '业务特点',
      },
      translate: {
        A: 'A-极度市场化',
        B: 'B-较市场化',
        C: 'C-大平台、合理激励',
        D: 'D-偏向国企风格，较保守',
        E: 'E-大国企、保守',
        F: '团队作战，精英模式',
      },
    }
  },
  methods: {
    quickEdit(field){
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:field==='业务特点/风格/资源来源'?'tagInput':'input',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
